<template lang="pug">
div
  template(v-if="configTemplate" v-for="config in Object.entries(configTemplateCopy)")
    //- .label {{config[0]}}
    template(v-for="subconfig in Object.entries(config[1])")
      b-field(
      :label="subconfig[1].label",
      label-position="on-border"
      )
        b-input(v-if="subconfig[1].type === 'text'" v-model="subconfig[1].value")
        b-numberinput(v-else-if="subconfig[1].type === 'number'" v-model="subconfig[1].value")
        b-select(v-else-if="subconfig[1].type === 'option'" v-model="subconfig[1].value")
          option(v-for="option in subconfig[1].options" :value="option.value") {{option.name}} 
</template>

<script>
export default {
  props: {
    configTemplate: Object
  },
  data() {
    return {
      configTemplateCopy: []
    }
  },
  watch: {
    configTemplateCopy() {
      this.$emit('updateConfigTemplate', this.configTemplateCopy);
    }
  },
  mounted() {
    this.configTemplateCopy = JSON.parse(JSON.stringify(this.configTemplate));
  }
}
</script>

<style scoped>

</style>